module.exports = __webpack_public_path__ + "img/red_nylon.ac667007.png";